import React, {Component} from 'react';
import SearchField from "./SearchField";
import {Col, Collapse, FormGroup} from "reactstrap";


class DetailedSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchQuery: undefined,
            collapse: false,
            fields: [],
            fieldsAndValues: {},
            key: 'sj2hj3hsj2hsh3j2',
        };

        this.clearAll = this.clearAll.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.onFieldChange = this.onFieldChange.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);
    }

    componentWillMount() {

        let fieldsAndValues = {};
        this.props.fields.map(field => {
            fieldsAndValues[field.accessor] = {value: undefined, operator: field.operator, type: field.type}
        });
        this.setState({fieldsAndValues})
    }

    clearAll() {
        let fieldsAndValues = {};
        this.props.fields.map(field => {
            fieldsAndValues[field.accessor] = {value: undefined, operator: field.operator}
        });

        this.setState({fieldsAndValues, searchQuery: undefined, key: Math.random()})
    }

    handleSearch() {
        let searchQuery = this.serializeFields();
        this.setState({searchQuery, loading: true}, () => this.props.onSearch(this.state.searchQuery))
    }

    onFieldChange(fieldName, value) {

        let {fieldsAndValues} = this.state;
        fieldsAndValues[fieldName].value = value;

        this.setState({fieldsAndValues});
    }

    serializeFields() {

        let serializedFields = "";
        let fieldsAndValues = this.state.fieldsAndValues;
        let fields = this.props.fields;

        let absentValueControlMap = {};

        //it's assumed and asserted at mount time that (TODO:assert)
        // - max_xx can't precede min_xx of same accessor,
        // - there must only 1 max_xx,min_xx pair,
        for (let i in fields) {
            const accessor = fields[i].accessor;
            if (fieldsAndValues[accessor].operator === '<=' && !!fieldsAndValues[accessor].value) { //max is defined
                const min_equivalentField = fieldsAndValues[`min_${this.correctFieldName(accessor)}`];
                if (!!min_equivalentField && !min_equivalentField.value) { //min_xx equivalent of same field accessor is defined and has no value
                    absentValueControlMap[this.correctFieldName(accessor)] = true //value of min_equivalent is ABSENT, hence the absentValueControlMap
                }
            }
        }

        for (let field in fieldsAndValues) {
            if (!!fieldsAndValues[field].value && serializedFields.length > 0) {
                serializedFields += "&";
            }
            if (fieldsAndValues[field].operator !== '>=' && fieldsAndValues[field].operator !== '<=') {
                if (!!fieldsAndValues[field].value) {
                    serializedFields += `${field}${fieldsAndValues[field].operator}${fieldsAndValues[field].value.trim()}`
                }
            } else {
                const correctFieldName = this.correctFieldName(field);
                if (fieldsAndValues[field].operator === '>=') { //min
                    if (absentValueControlMap[this.correctFieldName(field)]) { //minvalue absent and max exists. pass 0000-00 as min val
                        if (serializedFields.length > 0)
                            serializedFields += "&";
                        const fieldType = fieldsAndValues[field].type;
                        if (fieldType === 'date')
                            serializedFields += `${correctFieldName}=0001-01-01`;
                        else if (fieldType === 'datetime')
                            serializedFields += `${correctFieldName}=0001-01-01 00:00:00`;
                        else if (fieldType === 'localdatetime')
                            serializedFields += `${correctFieldName}=0001-01-01T00:00:00`;
                        else if (fieldType === 'month')
                            serializedFields += `${correctFieldName}=0001-01`;
                        else //number assumed. add custom fields as you like. (-99 etc., remember to customize the repository as well. [wait, I'm talking to myself <.< ])
                            serializedFields += `${correctFieldName}=0`
                    } else { // min value exists. just convert '>=' to '='
                        if (!!fieldsAndValues[field].value) {
                            if (!(typeof fieldsAndValues[field].value === "string")) {
                            serializedFields += `${correctFieldName}=${fieldsAndValues[field].value.format("YYYY-MM-DD")}`
                        } else{
                                serializedFields += `${correctFieldName}=${fieldsAndValues[field].value.trim()}`

                            }
                        }
                    }
                } else { //max value, just convert '<=' to '='
                    if (!!fieldsAndValues[field].value) {
                        if (!(typeof fieldsAndValues[field].value === "string")) {
                            serializedFields += `${correctFieldName}=${fieldsAndValues[field].value.format("YYYY-MM-DD")}`
                        }
                        else {
                            serializedFields += `${correctFieldName}=${fieldsAndValues[field].value.trim()}`
                        }

                    }
                }
            }
        }

        return serializedFields
    }

    correctFieldName(fieldName) {
        //split 2 times to obtain correct field name : e.g.: receivedDate -> ["","receivedDate"], and the [1]st element is "receivedDate"
        let splitted = fieldName.split(/min_|max_/);
        if (splitted.length === 1) {
            return splitted[0]
        } else {
            return splitted[1]
        }
    }

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            this.handleSearch();
        }
    }

    toggleCollapse() {
        this.setState(state => ({collapse: !state.collapse}));
    }
    render() {
        return (
            <div>
                <div key={this.state.key} className="FormRenk" style={{paddingTop:"1%",marginTop: "1%", marginBottom: "1%",paddingLeft: "3%",}}>
                    {this.props.fields && this.props.fields.length > 4 &&
                    <FormGroup row className="DetailSearch" onClick={this.toggleCollapse} style={{marginLeft:"-3%",marginRight:"0%",marginBottom:"%1"}}>
                        <Col sm={12} style={{left: "0%", height: "28px"}}>
                            <button type="button"
                                    sm={2}
                                    className="close pull-right"
                                    style={{
                                        outline: "none",
                                        fontSize: "xx-large",
                                        marginRight: "4px",
                                        marginTop: "-6px",
                                        marginLeft: "1%"
                                    }}
                                    title={!this.state.collapse ? "Aramayı Göster" : "Aramayı Gizle"}>
                                <span style={{fontSize: "x-large", border: "none"}} aria-hidden="true">
                                    <i className={!this.state.collapse ? "fas fa-angle-down" : "fas fa-angle-up"}
                                       style={{fontSize: "smaller"}}/>
                                </span>
                            </button>
                            <h4 className="close pull-right" sm={2}  style={{fontSize: "small", marginTop:'8px'}}>Gelişmiş Arama</h4>

                        </Col>
                    </FormGroup>}
                    {!this.state.collapse && <div className="row">
                    {
                        this.props.fields.map((searchField, i) => {
                                if (i < 4) {
                                    return <SearchField key={i} operator={searchField.operator}
                                                        onKeyPress={this.handleKeyPress}
                                                        type={searchField.type}
                                                        accessor={searchField.accessor}
                                                        label={searchField.label}
                                                        selectData={searchField.selectData}
                                                        listener={this.onFieldChange}/>
                                }
                            }
                        )
                    }
                    </div>}
                    {this.props.fields && this.props.fields.length > 4 &&
                    <Collapse isOpen={this.state.collapse}>
                        {this.props.loading &&
                        <div style={{
                            display: 'none',
                            position: 'absolute',
                            width: '100%',
                            background: 'lightgray none repeat scroll 0% 0%',
                            height: '100%',
                            zIndex: '200',
                            opacity: '0.4'
                        }}>
                        </div>}
                        <div className="row">
                            {
                                this.props.fields.map((searchField, i) =>
                                    <SearchField key={i} operator={searchField.operator}
                                                 onKeyPress={this.handleKeyPress}
                                                 type={searchField.type}
                                                 accessor={searchField.accessor}
                                                 label={searchField.label}
                                                 selectData={searchField.selectData}
                                                 listener={this.onFieldChange}/>
                                )
                            }
                        </div>
                    </Collapse>}
                    {/* Masaüstü görünüm için */}
                    <div className="row" style={{marginTop: '10px'}}>
                        <div className="col-md-6 d-none d-md-block">
                            <button type="button"
                                    style={{background: 'rgb(243, 157, 157)', width: '150px'}}
                                    className="TekBtn delete btn-icon" onClick={this.clearAll}>Tümünü Temizle</button>
                        </div>
                        <div className="col-md-6 d-none d-md-block">
                            <button type="button"
                                    style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', width: '150px', marginRight: '60px'}}
                                    className="TekBtn search btn-icon float-right" onClick={this.handleSearch}>Arama Yap</button>
                        </div>

                        {/* Mobil görünüm için */}
                        <div className="col-12 d-md-none d-flex justify-content-center">
                            <button type="button"
                                    style={{background: 'rgb(243, 157, 157)', width: '150px', marginBottom: '10px'}}
                                    className="TekBtn delete btn-icon" onClick={this.clearAll}>Tümünü Temizle</button>
                        </div>
                        <div className="col-12 d-md-none d-flex justify-content-center">
                            <button type="button"
                                    style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', width: '150px', marginBottom: '10px'}}
                                    className="TekBtn search btn-icon" onClick={this.handleSearch}>Arama Yap</button>
                        </div>
                    </div>


                </div>

            </div>
        )
    }
}

export default DetailedSearch;



// WEBPACK FOOTER //
// ./src/components/DetailedSearch/DetailedSearch.js